<mat-form-field [appearance]="inputAppearance()"
                [class.no-subscript]="noSubscript()"
                [ngClass]="inputClass()"
                >
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    [name]="name()"
    [ngxMatDatetimePicker]="datetimePicker"
    [min]="min"
    [max]="max"
    [matDatepickerFilter]="dateFilter()"
    [placeholder]="placeholder()"
    [value]="value"
    [required]="required()"
    (dateChange)="handleChange($event.value)"
    (focus)="openOnFocus() ? datetimePicker.open(): null"
    (click)="openOnFocus() ? datetimePicker.open(): null"
  >
  <mat-datepicker-toggle matSuffix [for]="$any(datetimePicker)"></mat-datepicker-toggle>
  <ngx-mat-datetime-picker
    #datetimePicker
    [showSpinners]="true"
    [touchUi]="true"
    [stepHour]="1"
    [stepMinute]="1"
    [enableMeridian]="true"
  >
  <ngx-mat-datepicker-actions>
    <button mat-button ngxMatDatepickerCancel>
      Cancelar
    </button>
    <button mat-button class="primary" ngxMatDatepickerApply>
      Aplicar
    </button>
  </ngx-mat-datepicker-actions>
  </ngx-mat-datetime-picker>
</mat-form-field>
@if (error()) {
    <mat-error>
      La hora debe estar dentro del rango permitido.
    </mat-error>
  }